import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  input,
} from '@angular/core';
import { Upsell } from '@core/models';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'app-upsell-toggle-card',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, TooltipModule],
  templateUrl: './upsell-toggle-card.component.html',
  styleUrl: './upsell-toggle-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsellToggleCardComponent {
  upsell = input.required<Upsell>();
  checked = input<boolean>(false);
  disabled = input<boolean>(false);
  disabledTooltip = input<string>('');

  @Output() toggled = new EventEmitter<HTMLInputElement>();

  onToggle(radio: HTMLInputElement) {
    if (this.disabled()) {
      return;
    }
    this.toggled.emit(radio);
  }
}
